import React from 'react'
import './HowItWorks.css'

const howItWorks = (props) => {
    return (
        <section class="home_hero how_it_works_page FlexVrCenter">
            <article class="art_hero_text">
                <h1 class="about-us-hero__title custom-how-it-works-title text-uppercase">How it Works</h1>
                <p style={{ textAlign: 'justify' }} class="about-us-hero__title">AV HERO is a technology platform that connects customers to a network of certified audiovisual technicians in a matter of minutes. Customers and HEROES create an online account, connect secure banking information, and request/receive jobs. All new, active and closed jobs are tracked through the AV HERO platform providing total transparency and archiving. AV HERO charges a rate of $75 per hour with a one hour minimum. After the first hour, billing will take place in 15-minute increments. Customers are given the opportunity to approve work and charges before billing occurs. Rate and re-request your favorite AV HEROES to ensure your optimal experience.</p>
            </article>
        </section>
    )
}
export default howItWorks 